import { Modal, Table } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import PROJET_ROW_TYPE from '../../../constants/common/projetRowType';
import STORAGE_KEY from '../../../constants/common/storage';
import type { EngagementCreditModal } from '../../../interfaces/common/EngagementCreditModal';
import type ProjetRow from '../../../interfaces/common/projetRow';
import { getProjetsInfosEngagements } from '../../../services/projet';
import './Modal.css';

interface ModalEngagementProps {
	onClose?: () => void;
	exercice?: string;
	projetRow: ProjetRow | null;
}

const ModalEngagement = ({
	onClose,
	projetRow,
	exercice,
}: ModalEngagementProps) => {
	const [data, setData] = React.useState<EngagementCreditModal | null>(null);
	const identifiantEntiteCompta = sessionStorage.getItem(
		STORAGE_KEY.ID_ENTITE_CPTA,
	);

	// biome-ignore lint/correctness/useExhaustiveDependencies: Pas besoin de 'identifiantEntiteCompta'
	React.useEffect(() => {
		const fetchData = async () => {
			const params: any = {
				exercice,
				identifiantEntiteCompta,
				sens: Sens.DEPENSE,
			};

			if (projetRow.type === PROJET_ROW_TYPE.PROJET) {
				params.identifiantProjet = projetRow.identifiant;
				params.hasComposant = projetRow.children?.length > 0 ? 1 : 0;
			} else {
				params.identifiantComposant = projetRow.identifiant;
			}

			setData(await getProjetsInfosEngagements(new URLSearchParams(params)));
		};

		fetchData();
	}, [projetRow]);

	return (
		<Modal closeIcon open size="small" onClose={onClose}>
			<Modal.Header>Écritures d&apos;engagement {exercice}</Modal.Header>
			<Modal.Content>
				<Table celled>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Date</Table.HeaderCell>
							<Table.HeaderCell>Numéro</Table.HeaderCell>
							<Table.HeaderCell>Libellé</Table.HeaderCell>
							<Table.HeaderCell>Tiers</Table.HeaderCell>
							<Table.HeaderCell>Montant</Table.HeaderCell>
						</Table.Row>
					</Table.Header>

					<Table.Body>
						{data?.infosLigneEngagement?.map((row) => (
							<Table.Row key={row.identifiant}>
								<Table.Cell>
									{new Intl.DateTimeFormat('fr-FR').format(new Date(row.date))}
								</Table.Cell>
								<Table.Cell>{row.numero}</Table.Cell>
								<Table.Cell>{row.libelle}</Table.Cell>
								<Table.Cell>{row.tiers}</Table.Cell>
								<Table.Cell>{formatMontant(row.montant)}</Table.Cell>
							</Table.Row>
						))}
						{data?.infosLigneEngagement.length === 0 && (
							<Table.Row>
								<Table.Cell colSpan={5} textAlign="center">
									Aucune écriture d&apos;engagement trouvée.
								</Table.Cell>
							</Table.Row>
						)}
					</Table.Body>

					<Table.Footer>
						<Table.Row>
							<Table.HeaderCell colspan="5">
								<div className="table-footer-total">
									<span>Total</span>
									<span>{formatMontant(projetRow.engagement)}</span>
								</div>
							</Table.HeaderCell>
						</Table.Row>
					</Table.Footer>
				</Table>
			</Modal.Content>
		</Modal>
	);
};

export default ModalEngagement;
